import Intercom from '@intercom/messenger-js-sdk'
import { useLoggedIn } from '@moonpig/web-core-auth'
import { useEffect } from 'react'
import { useApolloClient } from '@moonpig/web-core-graphql'
import { destroyBrowserCookie } from '@moonpig/web-core-browser-storage'
import { useExperimentBoolean } from '@moonpig/web-core-eppo/browser'
import { queryUserData } from './queryUserData'

const INTERCOM_APP_ID = 'ptt17buv'

export const CreateIntercomSession = () => {
  const client = useApolloClient()
  const { loggedIn } = useLoggedIn()

  const featureEnabled = useExperimentBoolean(
    'customer-intercom-user-session',
    {
      fallback: false,
    },
  )

  useEffect(() => {
    if (loggedIn && featureEnabled) {
      queryUserData(client.query).then(userData => {
        const { userDataJwt } = userData.intercom

        Intercom({
          region: 'eu',
          app_id: INTERCOM_APP_ID,
          hide_default_launcher: true,
          user_id: userData.id,
          email: userData.email,
          intercom_user_jwt: userDataJwt,
        })
      })
    } else {
      destroyBrowserCookie(`intercom-session-${INTERCOM_APP_ID}`, {
        path: '/',
      })
    }
  }, [client.query, loggedIn, featureEnabled])

  return null
}
